var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayIcon from '@mui/icons-material/PlayArrow';
var Input = function (_a) {
    var regenerateMessageDisabled = _a.regenerateMessageDisabled, sendMessageDisabled = _a.sendMessageDisabled, regenerateMessage = _a.regenerateMessage, sendMessage = _a.sendMessage;
    var _b = useState(''), messageContent = _b[0], setMessageContent = _b[1];
    var inputRef = useRef(null);
    var isDesktop = useMediaQuery('(min-width:768px)');
    var send = function () { return __awaiter(void 0, void 0, void 0, function () {
        var message, _1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    message = messageContent;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setMessageContent('');
                    if (!isDesktop && inputRef.current) {
                        inputRef.current.blur();
                    }
                    return [4 /*yield*/, sendMessage(message)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _1 = _a.sent();
                    setMessageContent(message);
                    if (!isDesktop && inputRef.current) {
                        inputRef.current.focus();
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleMessageContentChange = function (e) { return setMessageContent(e.target.value); };
    var handleSendKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (e.key !== 'Enter' || e.shiftKey) {
                return [2 /*return*/];
            }
            e.preventDefault();
            if (!messageContent.trim()) {
                return [2 /*return*/];
            }
            return [2 /*return*/, send()];
        });
    }); };
    var handleSendClick = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, send()];
    }); }); };
    var handleSendMouseDown = function (e) { return e.preventDefault(); };
    var handleRegenerateClick = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, regenerateMessage()];
    }); }); };
    var handleRegenerateKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (e.key === 'Enter') {
                return [2 /*return*/, regenerateMessage()];
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(Box, { width: "100%", display: "flex", flexDirection: "column", alignItems: "center", children: [isDesktop && (_jsx(Box, { pt: 3, children: _jsx(Button, { disabled: regenerateMessageDisabled, variant: "outlined", startIcon: _jsx(RefreshIcon, {}), onClick: handleRegenerateClick, onKeyDown: handleRegenerateKeyDown, children: "Regenerate response" }) })), _jsxs(Box, { maxWidth: "768px", width: "90%", pb: 1, pt: 1, display: "flex", flexDirection: "row", flexWrap: "nowrap", children: [_jsx(TextField, { autoFocus: true, fullWidth: true, placeholder: "Send a message", variant: "outlined", multiline: true, value: messageContent, onChange: handleMessageContentChange, onKeyDown: handleSendKeyDown, inputRef: inputRef, InputProps: {
                            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { disabled: sendMessageDisabled || !messageContent.trim(), onClick: handleSendClick, onMouseDown: handleSendMouseDown, edge: "end", children: _jsx(PlayIcon, {}) }) }))
                        } }), !isDesktop && (_jsx(IconButton, { disabled: regenerateMessageDisabled, onClick: handleRegenerateClick, onKeyDown: handleRegenerateKeyDown, children: _jsx(RefreshIcon, {}) }))] }), _jsx(Box, { pb: 2, maxWidth: "768px", width: "90%", textAlign: "center", children: _jsxs(Typography, { color: "text.secondary", sx: { fontSize: '14px' }, children: ["Please follow", ' ', _jsx(Link, { href: "https://app.smartsheet.com/b/form/83f9ca05f5254b81bc9a4f737c22c3e6", target: "blank", children: "this link" }), ' ', "to state your use case and", ' ', _jsx(Link, { href: "https://global-policies.essentials.dmgt.com/wp-content/uploads/sites/8/2023/08/Generative-AI-Policy-July-2023.pdf", target: "blank", children: "this link" }), ' ', "to see the DMGT AI Policy"] }) })] }));
};
export default Input;
